import { bl_b2b_payment_request_stmt_import_file_hdr_RowClass } from '../../../dbschema/bl_b2b_payment_request_stmt_import_file_hdr.model';
import { BaseContainerModel } from '../../base-container.model';

export class PaymentStatementImportFileHdrContainerModel extends BaseContainerModel {
    bl_b2b_payment_request_stmt_import_file_hdr: bl_b2b_payment_request_stmt_import_file_hdr_RowClass = new bl_b2b_payment_request_stmt_import_file_hdr_RowClass();
}